import React, { useEffect, useState } from "react";
import "./login.css";
import "../../styles/bg-responsive.css";
import "../../styles/auth-logo.css";
import sbfLogo from "../../assets/SBF-Logo-1.png";

import useAuth from "../../hooks/useAuthContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import carregando from "../../assets/Spinner-1s-200px.gif";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { isAdminTipo, redirectByTipo, isAcessoBloqueado } from "../../utils/userTipo";

const Login = () => {
  const { login, validarUser, verificaStorage, usuario } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const notifyError = (mensagem) => toast.error(mensagem, { theme: "colored" });
  const notifyInfo = (mensagem) => toast.info(mensagem, { theme: "colored" });
  const [showLoading, setShowLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    handleUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuario]);

  const handleUser = async () => {
    let user = await validarUser();
    if (user?.acessoBloqueado) {
      navigate("/acesso-em-breve");
      return;
    }
    if (!user) {
      user = await verificaStorage();
    }

    if (user?.acessoBloqueado) {
      navigate("/acesso-em-breve");
      return;
    }

    if (user) {
      if (isAdminTipo(user.tipo)) {
        navigate("/private/adm");
        return;
      }
      redirectByTipo(user.tipo, navigate);
    }
  };

  const handleLogin = async () => {
    setShowLoading(true);
    let response = await login(email, password);
    if (response) {
      if (response?.status === 200) {
        redirectByTipo(response.data.dadosUser.tipo, navigate);
        return;
      }
      if (isAcessoBloqueado(response)) {
        navigate("/acesso-em-breve");
        setShowLoading(false);
        return;
      }
      if (response?.status === 401) {
        notifyInfo(response.data.mensagem);
      } else if (response?.data?.mensagem) {
        notifyError(
          response.data.mensagem + (response.data.erro ? " - " + response.data.erro : "")
        );
      }
      setShowLoading(false);
    }
  };

  return (
    <div id="container-login">
      {/* <img src={bg} alt="SBF" id="bg-fundo" /> */}
      <div id="container-central">
        <div className="logo-wrapper">
          <img src={sbfLogo} alt="SBF" id="img-logo" />
        </div>
        <div id="container-inputs">
          <div className="email-input-wrapper">
            <input
              type="email"
              placeholder="Digite seu email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
              disabled={showLoading}
              className="email-input"
            />
          </div>
          
          <div className="password-input-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Digite sua senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
              disabled={showLoading}
              className="password-input"
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword(!showPassword)}
              disabled={showLoading}
              title={showPassword ? "Ocultar senha" : "Mostrar senha"}
            >
              {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
            </button>
          </div>

          <button
            className={`btn px-5 text-white ${showLoading ? "bt-loading" : ""
              }`}
            id="botao-acessar"
            onClick={() => {
              handleLogin();
            }}
          >
            {showLoading ? (
              <img src={carregando} width="30" alt="loading" />
            ) : (
              "Acessar"
            )}
          </button>

          <button
            className="btn btn-link"
            id="link-esqueci-senha"
            onClick={() => navigate('/esqueci-senha')}
            disabled={showLoading}
          >
            Esqueci minha senha
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
